export * from '@kiss/pipes/safe-html/safe-html.module';
